module.exports = __webpack_public_path__ + "static/media/rKelt.50426bc7.png";